export default __webpack_public_path__ + "static/media/dashboard.061762d8.png";